<template>
  <div :class="['live-event-data', { active }]">
    <slot />
    <div
      v-if="title"
      class="title"
    >
      {{ title }}
    </div>
    <div class="home">
      {{ number[0] }}
    </div>
    <div class="away">
      {{ number[1] }}
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'EventData',
  props: {
    numberData: {
      type: String,
      default: '0:0'
    },
    title: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const number = computed(() => props.numberData.split(':'))

    return {
      number
    }
  }
}
</script>

<style lang="scss" scoped>
.live-event-data {
  position: relative;
  z-index: 1;
  margin-left: 17px;
  font-weight: 500;
  text-align: center;

  .title {
    position: absolute;
    top: -22px;
    left: 0;
    width: 18px;
    height: 16px;
    color: #999;
    font-size: 12px;
    line-height: 16px;
  }

  img {
    width: 16px !important;
  }

  .home,
  .away {
    width: 18px;
    height: 28px;
    color: #fff;
    font-size: 12px;
    line-height: 28px;
  }

  .home {
    margin-bottom: 4px;
  }

  &.active {
    .home,
    .away,
    .title {
      color: #ffca27;
      font-family: 500;
      font-size: 14px;
    }
  }
}
</style>
